module.exports = __webpack_public_path__ + "static/media/exemptaxLogo.f50d49f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/exemptaxLogo.png
// module id = 1427
// module chunks = 0